import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ValidatorService {

  constructor() { }

  isEmpty(value: any) {
    if (value === null) {
      return true;
    }

    if (value === undefined) {
      return true;
    }

    if (typeof value === 'string') {
      if (value.trim().length === 0) {
        return true;
      }
    }

    return false;
  }


  isCpf(cpf: string) {
    if (cpf != null) {
      // Fetch only numbers
      cpf = cpf.replace(/[^0-9]/g, '');

      if (cpf.length != 11) {
        return false;
      }

      const BLACKLIST: Array<string> = [
        '00000000000',
        '11111111111',
        '22222222222',
        '33333333333',
        '44444444444',
        '55555555555',
        '66666666666',
        '77777777777',
        '88888888888',
        '99999999999',
        '12345678909',
      ];
      if (BLACKLIST.indexOf(cpf) !== -1) {
        return false;
      }

      const verifierDigit: any = (digits: string): number => {
        const numbers: Array<number> = digits
            .split('')
            .map(number => {
              return parseInt(number, 10);
            });
        const modulus: number = numbers.length + 1;
        const multiplied: Array<number> = numbers.map((number, index) => number * (modulus - index));
        const mod: number = multiplied.reduce((buffer, number) => buffer + number) % 11;

        return ((mod < 2) ? 0 : (11 - mod));
      }

      let numbers: string = cpf.substr(0, 9);
      numbers += verifierDigit(numbers);
      numbers += verifierDigit(numbers);

      return (numbers.substr(-2) === cpf.substr(-2));
    } else {
      return false;
    }
  }
}
